export class User {
    id:string = ""
    email:string|null = null
    dialCode:string = ""
    phoneNumber:string|null = null

    companyId:string = "" //TODO usefull?
    firstName:string = ""
    lastName:string = ""
    ssoIdentifier:string|null = null
    roles:Array<string> = []
}